import { Model } from 'jms-domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const fixBurnerBasePropsTransformer = configuratorInterface.transformerBuilder.when
  .entity([Model.BurnerBaseW24.type])
  .modified({ atFields: ['variant'] })
  .then.applySideEffect(ctx => {
    const entityId = ctx.update.entityId as Model.BurnerBaseW24['id']
    const delta = ctx.update.stateDelta as Partial<Model.BurnerBaseW24>

    return [
      configuratorInterface.updates.DomainEntityModification({
        entityId,
        stateDelta: {
          variant: delta.variant,
          handing: delta.variant === Model.BurnerBaseW24Variant.Lowered ? Model.Handing.top : Model.Handing.left,
        },
        updateTag: 'fixBurnerBaseProps',
      }),
    ]
  })
  .build('Fix Burner Base props when switching variant')
